import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
const testimonials = [{
  quote: 'Переїхав до Києва з іншого міста й не знав, з чого почати. Хлопці все зробили за мене — через 2 дні вже мав прописку. Жодних черг і нервів.',
  author: 'Андрій М.',
  role: 'Клієнт'
}, {
  quote: 'Потрібна була прописка для оформлення документів. Проконсультували безкоштовно, одразу запропонували рішення. Все офіційно, все швидко. Рекомендую.',
  author: 'Олександр К.',
  role: 'Клієнт'
}, {
  quote: 'Раніше намагався зробити сам — відмовили двічі. Звернувся сюди, підготували документи правильно, з першого разу все пройшло. Дякую за професіоналізм.',
  author: 'Віталій С.',
  role: 'Клієнт'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-surface" data-id="element-142">
      <div className="max-w-7xl mx-auto px-6" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-145">
            Відгуки клієнтів
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-146">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-background p-8 rounded-3xl border border-border flex flex-col" data-id="element-147">
              <p className="text-lg text-primary leading-relaxed mb-8 flex-grow" data-id="element-148">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-149">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-secondary" data-id="element-150">
                  <User size={18} data-id="element-151" />
                </div>
                <div data-id="element-152">
                  <div className="font-medium text-sm text-primary" data-id="element-153">
                    {item.author}
                  </div>
                  <div className="text-xs text-secondary" data-id="element-154">{item.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}